var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApi, fetchBaseQuery, } from '@reduxjs/toolkit/query/react';
import { eventBus } from '@/context/shared/eventBus';
import { getKeycloakInstance } from '@/context/shared/keycloak';
import { MIN_VALIDITY_KEYCLOAK } from '@/tools/constants';
var baseQuery = fetchBaseQuery({
    baseUrl: process.env.API_HOST,
    prepareHeaders: function (headers) { return __awaiter(void 0, void 0, void 0, function () {
        var keycloak;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getKeycloakInstance()];
                case 1:
                    keycloak = _a.sent();
                    if (keycloak === null || keycloak === void 0 ? void 0 : keycloak.token) {
                        headers.set('Authorization', "Bearer ".concat(keycloak.token));
                    }
                    return [2 /*return*/, headers];
            }
        });
    }); },
    // Кастомный сериализатор параметров
    paramsSerializer: function (params) {
        var searchParams = new URLSearchParams();
        var _loop_1 = function (key) {
            var value = params[key];
            if (Array.isArray(value)) {
                // Для каждого элемента массива добавляем отдельный параметр
                value.forEach(function (item) {
                    // 'key' для ?ids=1&ids=2
                    // или `${key}[]` для ?ids[]=1&ids[]=2
                    searchParams.append(key, item);
                });
            }
            else if (value !== undefined) {
                searchParams.append(key, value);
            }
        };
        for (var key in params) {
            _loop_1(key);
        }
        return searchParams.toString();
    },
});
var baseQueryWithReauth = function (args, api, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var result, keycloak, refreshed, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, baseQuery(args, api, extraOptions)];
            case 1:
                result = _d.sent();
                if (!(((_b = result.error) === null || _b === void 0 ? void 0 : _b.status) === 401)) return [3 /*break*/, 10];
                return [4 /*yield*/, getKeycloakInstance()];
            case 2:
                keycloak = _d.sent();
                _d.label = 3;
            case 3:
                _d.trys.push([3, 8, , 9]);
                return [4 /*yield*/, keycloak.updateToken(MIN_VALIDITY_KEYCLOAK)];
            case 4:
                refreshed = _d.sent();
                if (!refreshed) return [3 /*break*/, 6];
                return [4 /*yield*/, baseQuery(args, api, extraOptions)];
            case 5:
                // Retry the initial query
                result = _d.sent();
                return [3 /*break*/, 7];
            case 6:
                // Failed to refresh token - redirect to login
                keycloak === null || keycloak === void 0 ? void 0 : keycloak.login();
                _d.label = 7;
            case 7: return [3 /*break*/, 9];
            case 8:
                _a = _d.sent();
                keycloak === null || keycloak === void 0 ? void 0 : keycloak.login();
                return [3 /*break*/, 9];
            case 9: return [3 /*break*/, 11];
            case 10:
                if (typeof ((_c = result.error) === null || _c === void 0 ? void 0 : _c.status) === 'number') {
                    eventBus.emit('apiError', { error: result.error });
                }
                _d.label = 11;
            case 11: return [2 /*return*/, result];
        }
    });
}); };
/** Шаблон апи */
export var templateApi = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: function () { return ({}); },
});
